import type { CSSObject } from "type/tss";
import { Theme } from "@mui/material/styles";

export const styles = (theme: Theme) => {
	return ({
		form: {
			display: "flex",
			flexDirection: "column",
			justifyContent: "center",
			width: "100%",
		},
		textField: {
			marginBottom: 16,
		},
		alignVertical: {
			display: "flex",
			alignItems: "center",
			justifyContent: "space-between",
		},
		login: {
				marginTop: 20,
		},
		forgotLink: {
			alignSelf: "flex-end",
		},
		createAccountContainer: {
			display: "flex",
			flexDirection: "row" as const,
			alignItems: "center",
			justifyContent: "center",
			paddingTop: 16,
			gap: 4,
		},
		externalLinkIcon: {
			verticalAlign: "middle",
			marginLeft: 4,
		},
		error: {
			color: theme.palette.error.main,
		}
	} satisfies Record<string, CSSObject>);
};
